import React, { useState } from "react";
import ReactJson from "react-json-view";

const Bodytext = ({ data }) => {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const jsonString = JSON.stringify(data, null, 2);
  const isLargeJson = jsonString.split("\n").length > 6;

  return (
    <>
      {/* Main JSON Block */}
      <div
        style={{
          position: "relative",
          padding: "10px",
          background: "#002b36",
          borderRadius: "8px",
          maxHeight: isLargeJson ? "200px" : "auto",
          overflow: "hidden",
        }}
      >
        <button
          onClick={handleCopy}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#5e7660",
            color: "white",
            border: "none",
            padding: "5px 10px",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "11px",
            zIndex: 2,
          }}
        >
          {copied ? "Copied! ✅" : "Copy 📋"}
        </button>

        <ReactJson
          src={data}
          name={false}
          theme="ocean"
          collapsed={isLargeJson ? 1 : false}
          enableClipboard={false}
          displayDataTypes={false}
        />

        {/* View More Button */}
        {isLargeJson && (
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "50px",
              background:
                "linear-gradient(to top, rgba(0, 43, 54, 1), rgba(0, 43, 54, 0))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              onClick={() => setShow(true)}
              style={{
                background: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#000000",
              }}
            >
              View More
            </button>
          </div>
        )}
      </div>

      {/* Custom Modal */}
      {show && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <div style={styles.modalHeader}>
              <button onClick={() => setShow(false)} style={styles.closeBtn}>
                ✖
              </button>
            </div>
            <div style={styles.modalBody}>
              <button onClick={handleCopy} style={styles.copyBtn}>
                {copied ? "Copied! ✅" : "Copy 📋"}
              </button>
              <ReactJson
                src={data}
                name={false}
                theme="ocean"
                collapsed={false}
                enableClipboard={false}
                displayDataTypes={false}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// CSS-in-JS styles for modal
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modalBox: {
    background: "#002b36",
    borderRadius: "8px",
    width: "80%",
    maxHeight: "80%",
    overflowY: "auto",
    padding: "20px",
    position: "relative",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "flex-end",
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    color: "white",
    fontSize: "20px",
    cursor: "pointer",
  },
  modalBody: {
    marginTop: "10px",
    maxHeight: "600px",
    overflowY: "auto",
  },
  copyBtn: {
    position: "absolute",
    top: "20px",
    right: "50px",
    background: "#5e7660",
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "4px",
    fontSize: "11px",
  },
};

export default Bodytext;
